import { FC } from 'react';

import {
  BOOKING_EMAIL,
  INDIVIDUAL_OFFER_URL,
  LEGAL_ENTITY_OFFER_URL,
  MAX_COMMUNITY_URL,
  TELEGRAM_CHANNEL_URL,
} from 'shared/containers/Superhost/const';

import style from './Footer.css';
import { IconSocialMax24, IconSocialTelegram24 } from '@cian/ui-kit-design-tokens/icons';

export const Footer: FC = () => {
  return (
    <footer className={style['section']}>
      <div className={style['inner']}>
        <a href={BOOKING_EMAIL} className={style['email']}>
          booking@cian.ru
        </a>
        <div className={style['socials']}>
          <a href={MAX_COMMUNITY_URL} className={style['social']} target="_blank" rel="noopener noreferrer">
            <IconSocialMax24 color="current_color" />
          </a>
          <a href={TELEGRAM_CHANNEL_URL} className={style['social']} target="_blank" rel="noopener noreferrer">
            <IconSocialTelegram24 color="current_color" />
          </a>
        </div>
        <div className={style['links']}>
          <a className={style['link']} href={LEGAL_ENTITY_OFFER_URL}>
            Оферта для юрлиц
          </a>
          <a className={style['link']} href={INDIVIDUAL_OFFER_URL}>
            Оферта для физлиц
          </a>
        </div>
      </div>
    </footer>
  );
};
